<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">Consignment Inventory</h5>
            </div>
            <hr />
            <h6>Consignment Product Lookup</h6>
            <div class="row">
                <div class="col-md-6 col-lg-4 text-start mt-3">
                    <label for="txtSearchField">Search Field</label>
                    <select class="form-select" id="txtSearchField" [(ngModel)]="selectedSearchField" name="searchField"
                        (change)="onSearchFieldChange()">
                        <option [ngValue]="null" disabled>Select</option>
                        @for (option of searchFieldOptions; track option.id) {
                        <option [ngValue]="option.id">{{ option.name | wordReplace }}</option>
                        }
                    </select>
                </div>
                <div class="col-md-6 col-lg-4 text-start mt-3">
                    <label for="txtSearchValue">Search Value</label>
                    <input *ngIf="selectedSearchField !== 3" id="txtSearchValue" type="text" class="form-control"
                        (input)="onSearchChange($event.target.value)" />

                    <ejs-datepicker *ngIf="selectedSearchField === 3" id="txtSearchDate" format="MM/dd/yyyy"
                        placeholder="Select Date" (change)="onDateChange($event)">
                    </ejs-datepicker>

                </div>
            </div>
            <div class="row">
                <div class="col-12 text-start mt-3">
                    <ejs-grid [dataSource]="consignmentInventory" (recordClick)="onRowSelected($event)"
                        [allowFiltering]="false" height="300">
                        <e-columns>
                            <e-column field="StockId" headerText="Stock ID" textAlign="left" width="135"></e-column>
                            <e-column field="ProductName" headerText="Product Name" textAlign="left"
                                width="200"></e-column>
                            <e-column field="PrintLabel" headerText="Print Label" width="110" textAlign="Center">
                                <ng-template #template let-data>
                                    <div (click)="$event.stopPropagation();">
                                        <input type="checkbox" class="form-check-input" [checked]="data.PrintLabel"
                                            (change)="onPrintLabelChange(data, $event)" />
                                    </div>
                                </ng-template>
                            </e-column>
                            <e-column field="Price" headerText="Price" textAlign="Right" format="C2"
                                width="100"></e-column>
                            <e-column field="VendorAlphaId" textAlign="left" width="110">
                                <ng-template #headerTemplate>
                                    {{ 'Vendor ID' | wordReplace }}
                                </ng-template>
                            </e-column>
                            <e-column field="VendorName" textAlign="left" width="180">
                                <ng-template #headerTemplate>
                                    {{ 'Vendor Name' | wordReplace }}
                                </ng-template>
                            </e-column>
                            <e-column field="ConsignSpaceId" textAlign="left" width="100">
                                <ng-template #headerTemplate>
                                    {{ 'Booth ID' | wordReplace }}
                                </ng-template>
                            </e-column>
                            <e-column field="CommisionPercent" headerText="Commission(%)" textAlign="right" width="140"
                                [valueAccessor]="percentFormatter">
                            </e-column>
                            <e-column field="CommisionAmount" headerText="Commission Amount" textAlign="right"
                                width="180" format="C2">
                            </e-column>
                            <e-column field="DateAdded" headerText="Date Added" textAlign="Left" width="120">
                            </e-column>
                            <e-column field="DateActive" headerText="Date Active" textAlign="Left" width="120">
                            </e-column>
                            <e-column field="DateExpire" headerText="Date Expire" textAlign="Left" width="120">
                            </e-column>
                            <e-column headerText='Delete' field="Delete" width='80' textAlign="Center">
                                <ng-template #template let-data>
                                    <ejs-tooltip id='tooltipCellDeleteCon' target="#conInventoryDel"
                                        position='LeftCenter' (beforeOpen)="onBeforeOpen($event)">
                                        <a id="conInventoryDel" [userPermissionHandler]="deletePermissionHandlerData"
                                            (click)="deleteConsignmentProduct(data);$event.stopPropagation()"> <img
                                                src="./assets/images/delete.svg" class="img-fluid" /></a>
                                    </ejs-tooltip>
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        <div class="form-check">
                            <input type="checkbox" id="chkSelectAll" class="form-check-input"
                                [(ngModel)]="selectAllLabels" (ngModelChange)="onSelectAllLabels()"
                                [ngModelOptions]="{standalone: true}" />
                            <label class="form-check-label" for="chkSelectAll">
                                Select All
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-12 col-lg-4"></div>
                <div class="col-md-12 col-lg-4 text-md-start text-lg-end mt-2">
                    <div class="input-group" [formGroup]="barcodeTempForm">
                        <label for="usedLabels" class="input-group-text">Used Labels</label>
                        <input type="text" id="usedLabels" class="form-control form-control-sm me-2"
                            formControlName="UsedLabel" (keydown)="allowOnlyDigits($event, 2)"
                            (blur)="onUsedLabelBlur()">
                        <ejs-tooltip id='tooltipbtnNewConsignment' target="#targetNewConsignment" position='LeftCenter'
                            (beforeOpen)="onBeforeOpen($event)">
                            <button id="targetNewConsignment" class="btn btnAS"
                                [userPermissionHandler]="createPermissionHandlerData"
                                (click)="openConsignmentModal()">New</button>
                        </ejs-tooltip>
                    </div>
                </div>
                <div class="col-md-12 col-lg-4 text-md-start text-lg-end mt-2">
                    <button type="button" class="btn btnAS me-1" [disabled]="!isPrintEnabled"
                        (click)="onReportView()">Print
                        Labels</button>
                    <button type="button" class="btn btn-orange" (click)="onCancel()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal -->
<div class="modal fade" id="consignmentInventoryModal" tabindex="-1" aria-labelledby="consignmentInventoryModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="consignmentInventoryModalLabel">Consignment Inventory</h1>
                <button type="button" class="btn-close" (click)="closeModalById('consignmentInventoryModal')"></button>
            </div>
            <form [formGroup]="consignmentForm">
                <div class="modal-body">
                    <div class="row g-3">
                        <div class="col-md-3">
                            <label class="form-label">Stock ID<span class="text-danger">*</span></label>
                            <div class="input-group">
                                <!-- Fixed prefix -->
                                <span class="input-group-text">CON</span>
                                <input type="text" class="form-control" formControlName="StockId" maxlength="12"
                                    (keydown)="allowOnlyAlphanumeric($event)" [readonly]="isEditMode">
                            </div>

                        </div>
                        <div class="col-md-9">
                            <label class="form-label">Product Name<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" formControlName="ProductName" maxlength="50">
                        </div>
                        <div class="col-md-6">
                            <div class="row mt-md-4">
                                <div class="col-auto">
                                    <label class="form-check-label ms-1 mt-1" for="vendorId">
                                        {{'Vendor ID' | wordReplace}}
                                    </label><span class="text-danger">*</span>
                                </div>
                                <div class="col-3">
                                    <input type="text" id="vendorId" class="form-control form-control-sm"
                                        formControlName="MarketVendorId" />
                                </div>
                                <div class="col-5">
                                    <input type="text" id="vendorName" class="form-control form-control-sm"
                                        formControlName="VendorName" />
                                </div>
                                <div class="col-auto">
                                    <button type="button" class="btn btn-dark" (click)="openVendorSearchModal()">
                                        <img src="./assets/images/search.svg" class="img-fluid" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">{{'Consignment Booth ID' | wordReplace}}<span
                                    class="text-danger">*</span></label>
                            <select class="form-select" formControlName="ConsignSpaceId">
                                <option value="" disabled>{{'Select Booth ID' | wordReplace }}</option>
                                @for (b of consignmentBoothIDs; track b) {
                                <option [value]="b">{{ b }}</option>
                                }
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Commission (%)</label>
                            <input type="text" class="form-control" formControlName="CommisionPercent"
                                appPercentageFormatter value="0.00%" maxlength="10" />
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Price<span class="text-danger">*</span></label>
                            <input type="text" class="form-control text-start" formControlName="Price"
                                appCurrencyFormatter value="$0.00" />
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Commission Amount</label>
                            <input type="text" class="form-control text-start" formControlName="CommisionAmount"
                                readonly>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Date Added</label>
                            <ejs-datepicker class="form-control p-0" formControlName="DateAdded"></ejs-datepicker>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Active Consignment Date</label>
                            <ejs-datepicker class="form-control p-0" formControlName="DateActive" [min]="minExpiryDate"
                                (change)="onDateChangeCheck('DateActive', $event)"></ejs-datepicker>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Expiry Consignment Date</label>
                            <ejs-datepicker class="form-control p-0" formControlName="DateExpire" [min]="minExpiryDate"
                                (change)="onDateChangeCheck('DateExpire', $event)"></ejs-datepicker>
                        </div>

                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btnAS" (click)="saveConsignmentProduct()"
                        [disabled]="isEditMode && !isUpdateEnabled"> {{ isEditMode ? 'Update'
                        : 'Add' }}</button>
                    <button type="button" class="btn btn-orange"
                        (click)="closeModalById('consignmentInventoryModal')">Cancel</button>
                </div>
            </form>
        </div>
    </div>
</div>
<!-- Modal with Vendor Search Component -->
<div class="modal fade" id="vendorSearchModal" #vendorSearchModal data-bs-parent="#consignmentInventoryModal"
    tabindex="-1" aria-labelledby="vendorSearchLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="vendorSearchLabel">
                    {{'Select Vendor' | wordReplace}}
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <app-vendor-search [isVendorPopUp]="true" [VendorFilterOption]="VendorFilterOption"
                    (vendorSearchRoute)="onVendorSelected($event)">
                </app-vendor-search>
            </div>
        </div>
    </div>
</div>